/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-empty */
import { useEffect, useState } from "react";
import useAPIHandler from "../../../hook/use-api-handler";
import useSnackbar from "../../../hook/use-snakbar";
import {
  getErrorDetailsFn,
  parseOnlyNumericValue,
  removeAllSpaces,
  safeToString,
  sliceText,
} from "../../../utils/common";
import { removeMultipleSpace } from "../../../utils/logger";
import { EMP_SETUP_CONST } from "./benefit-constant";
import { EmpSetupSchema, schema } from "./benefit-validation";

const useBenifitService = () => {
  const INITIAL_EMP_SETUP = {
    employmentType: [],
    provisionDays: null,
    isNoticePeriod: false,
    shiftManagement: false,
    loginTime: "",
    logoutTime: "",
    breakTime: null,
    workMode: [],
    leave_type: "",
    leave_staging: null,
    prefix: "",
  };

  const [openBenefitsModal, setOpenBenefitsModal] = useState(false);
  const [openBenefitsModalStep2, setOpenBenefitsModalStep2] = useState(false);

  const [createUpdateLoading, setCreateUpdateLoading] = useState(false);
  const [benefitViewData, setbenefitViewData] = useState({});
  const [empSetup, setEmpSetup] = useState(INITIAL_EMP_SETUP);
  const [empsetuperr, setEmpsetuperr] = useState({});

  const {
    snackbarVisible,
    snackbarMessage,
    openSnackbar,
    closeSnackbar,
    snackColor,
  } = useSnackbar();

  const { fetchData } = useAPIHandler();
  const [benifitData, setBenifitData] = useState({
    labour_welfare_fund: false,
    ot_application: false,
    incentive_application: false,
    ex_gratia: false,
    bonus_status: false,
  });

  const handleOpenBenefitsModal = () => {
    setBenifitData(benefitViewData);
    setOpenBenefitsModal(true);
  };

  const handleOpenBenefitsModalStep2 = () => {
    setEmpSetup(benefitViewData);
    setOpenBenefitsModalStep2(true);
  };
  const handleCloseBenefitsModal = () => setOpenBenefitsModal(false);
  const handleCloseBenefitsModalStep2 = () => setOpenBenefitsModalStep2(false);
  const [errors, setErrors] = useState({});

  async function onSubmit() {
    setCreateUpdateLoading(true);

    const {
      bonus_status,
      ex_gratia,
      incentive_application,
      ot_application,
      labour_welfare_fund,
    } = benifitData;
    const {
      employmentType,
      // isProvisionPeriod,
      provisionDays,
      isNoticePeriod,
      noticeDays,
      shiftManagement,
      loginTime,
      logoutTime,
      breakTime,
      workMode,
      leave_type,
      prefix,
      leave_staging,
    } = empSetup;

    const { error } = schema.validate(
      {
        bonus_status,
        ex_gratia,
        incentive_application,
        ot_application,
        labour_welfare_fund,
      },
      {
        abortEarly: false,
      }
    );

    const { error: empsetuperr } = EmpSetupSchema.validate(
      {
        employmentType,
        // isProvisionPeriod,
        provisionDays,
        isNoticePeriod,
        noticeDays,
        shiftManagement,
        loginTime,
        logoutTime,
        breakTime,
        workMode,
        leave_type,
        prefix,
        leave_staging,
      },
      {
        abortEarly: false,
        context: { ...empSetup },
      }
    );

    if (empsetuperr && empsetuperr?.details?.length > 0) {
      const validationErrors = error?.details?.reduce((acc, err) => {
        const pathname = err.path.join(".");
        acc[pathname] = err.message;
        return acc;
      }, {});

      const validationEmpSetup = empsetuperr?.details.reduce((acc, err) => {
        const pathname = err.path.join(".");
        acc[pathname] = err.message;
        return acc;
      }, {});

      // setErrors(validationErrors);
      setEmpsetuperr(validationEmpSetup);
      setCreateUpdateLoading(false);
    } else {
      setErrors({});
      setEmpsetuperr({});
      let data = {
        bonus_status,
        ex_gratia,
        incentive_application,
        ot_application,
        labour_welfare_fund,
        employmentType,
        // isProvisionPeriod,
        provisionDays,
        isNoticePeriod,
        noticeDays,
        shiftManagement,
        loginTime,
        logoutTime,
        breakTime,
        workMode,
        prefix,
        leave_type,
        leave_staging,
      };
      // if (data.employmentType.includes("full_time")) {

      data = {
        ...data,provisionDays:Number(provisionDays)
      };
      // } else {
      //   data.isProvisionPeriod = false;
      //   data.provisionDays = null;
      //   data.isNoticePeriod = false;
      //   data.noticeDays = null;
      // }
      try {
        fetchData({
          data: data,
          url: "/organization/create-organization-benefit",
          method: "POST",
        })
          .then((res) => {
            openSnackbar({
              message: `Organization Configuration ${benifitData?.org_id ? "Updated" : "Added"} Successfully!`,
              color: "success",
            });
            setCreateUpdateLoading(false);
            handleCloseBenefitsModal();
            handleCloseBenefitsModalStep2();

            getBenefitDataFn();
          })
          .catch((err) => {
            handleCloseBenefitsModal();
            setCreateUpdateLoading(false);
          });
      } catch (error) {
        const { message, errorObj } = getErrorDetailsFn(error);
        handleCloseBenefitsModal();

        openSnackbar({
          message,
          color: "danger",
        });
        setErrors(errorObj);

        setCreateUpdateLoading(false);
      }
    }
  }

  const handleChangeFunction = (e, customName, customOptions = {}) => {
    let name = customName;
    let value = e;
    if (!customName) {
      name = e.target.name;
      value = e.target.value;
    }

    if (customOptions.noSpace === true) {
      value = removeAllSpaces(safeToString(value));
    }

    value = removeMultipleSpace(safeToString(value));

    if (customOptions.upperCase === true) {
      value = safeToString(value).toUpperCase();
    }
    if (customOptions.onlyNumber === true) {
      value = parseOnlyNumericValue(value);
    }

    if (customOptions.maxLength) {
      value = sliceText(safeToString(value), customOptions.maxLength);
    }
    if (customOptions.boolean) {
      if (!customName) {
        value = e.target.value;
      } else {
        value = e;
      }
    }

    setBenifitData((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));

    const fieldSchema = schema.extract(name);
    const { error } = fieldSchema.validate(value);

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error ? error.details[0].message : undefined,
    }));
  };

  const employmentSetupOnChngFn = (e, field) => {
    if (
      field === "employmentType" ||
      field === "workMode" ||
      field === "leave_type" ||
      field === "leave_staging"
    ) {
      if (field === "employmentType" && !e.includes("probationary")) {
        const info = empSetup;
        delete info.provisionDays;
        setEmpSetup({ ...info, [field]: e });
      } else {
        setEmpSetup({ ...empSetup, [field]: e });
      }

      const temp = empsetuperr;
      delete temp[field];
      setEmpsetuperr(temp);
    }
    if (field === "loginTime" || field === "logoutTime") {
      const temp = { ...empSetup, [field]: `${e?.target?.value}` };
      setEmpSetup(temp);
      OnBlureEmpSetup(e, field);
    }
    if (["isNoticePeriod", "shiftManagement"].includes(field)) {
      setEmpSetup({ ...empSetup, [field]: e });
    }
    if (["prefix"].includes(field)) {
      setEmpSetup({ ...empSetup, [field]: e.target.value });
    } else if (["provisionDays", "noticeDays", "breakTime"].includes(field)) {
      let value;
      if (
        EMP_SETUP_CONST[field].customOptions &&
        EMP_SETUP_CONST[field].customOptions?.formatValueFn
      ) {
        value = EMP_SETUP_CONST[field].customOptions?.formatValueFn(
          e?.target?.value
        );
      }

      setEmpSetup({ ...empSetup, [field]: value });
      OnBlureEmpSetup(e, field);
    }
  };

  const OnBlureEmpSetup = (e, name) => {
    const { value } = e.target;
    const data = {
      ...empSetup,
      [name]: value,
    };
    const { error } = EmpSetupSchema.validate(data, {
      abortEarly: false,
      context: { ...empSetup },
    });

    if (error) {
      const fieldError = error.details.find((err) => err.path[0] === name);
      if (fieldError) {
        setEmpsetuperr((prevErrors) => ({
          ...prevErrors,
          [name]: fieldError.message,
        }));
      } else {
        setEmpsetuperr((prevErrors) => {
          const { [name]: removedError, ...restErrors } = prevErrors;
          return restErrors;
        });
      }
    } else {
      setEmpsetuperr((prevErrors) => {
        const { [name]: removedError, ...restErrors } = prevErrors;
        return restErrors;
      });
    }
  };

  const [getProfileLoading, setgetProfileLoading] = useState(false);

  function getBenefitDataFn() {
    setgetProfileLoading(true);
    fetchData({ url: "/organization/get-organization-benefit" })
      .then((res) => {
        try {
          setBenifitData(res?.data || {});
          setbenefitViewData(res?.data || {});
          setEmpSetup(res?.data || {});
          setgetProfileLoading(false);
        } catch (error) {
          setgetProfileLoading(false);
        }
      })
      .catch((err) => {
        setgetProfileLoading(false);
      });
  }

  useEffect(() => {
    getBenefitDataFn();
  }, []);

  return {
    handleChangeFunction,
    onSubmit,
    errors,
    benifitData,
    createUpdateLoading,
    snackbarVisible,
    snackbarMessage,
    openSnackbar,
    closeSnackbar,
    snackColor,
    openBenefitsModal,
    setOpenBenefitsModal,
    openBenefitsModalStep2,
    setOpenBenefitsModalStep2,
    handleCloseBenefitsModal,
    handleOpenBenefitsModal,
    handleOpenBenefitsModalStep2,
    handleCloseBenefitsModalStep2,
    getProfileLoading,
    benefitViewData,
    empSetup,
    employmentSetupOnChngFn,
    OnBlureEmpSetup,
    empsetuperr,
  };
};

export default useBenifitService;


